import { Brush } from "@mui/icons-material";
import {
  Box,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../store/slices/authSlice";
import { saveSiteStyle, setSiteStyle } from "../store/slices/themeSlice";
import {
  SITE_STYLE_IDS,
  SITE_STYLE_SWATCHES,
} from "../theme/themeConfig";

const ThemeSwitcher = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { siteStyle } = useSelector((state) => state.theme);
  const { user } = useSelector((state) => state.auth);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleStyleChange = (styleId) => {
    dispatch(setSiteStyle(styleId));
    dispatch(saveSiteStyle(styleId)).then((result) => {
      if (saveSiteStyle.fulfilled.match(result) && user) {
        dispatch(
          setUser({
            ...user,
            site_style: result.payload,
          })
        );
      }
    });
    handleClose();
  };

  const renderSwatch = (styleId) => {
    const colors = SITE_STYLE_SWATCHES[styleId];
    return (
      <Box sx={{ display: "flex", gap: 0.5, mr: 1 }}>
        <Box
          sx={{
            width: 14,
            height: 14,
            borderRadius: "50%",
            bgcolor: colors.primary,
            border: "1px solid rgba(0,0,0,0.12)",
          }}
        />
        <Box
          sx={{
            width: 14,
            height: 14,
            borderRadius: "50%",
            bgcolor: colors.secondary,
            border: "1px solid rgba(0,0,0,0.12)",
          }}
        />
      </Box>
    );
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        size="small"
        sx={{
          ml: 1,
          color: "inherit",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
          },
        }}
        aria-label={t("theme.switcherLabel")}
      >
        <Brush />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            minWidth: 200,
            mt: 1,
          },
        }}
      >
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ px: 2, py: 1, display: "block" }}
        >
          {t("theme.title")}
        </Typography>
        {SITE_STYLE_IDS.map((styleId) => (
          <MenuItem
            key={styleId}
            onClick={() => handleStyleChange(styleId)}
            selected={siteStyle === styleId}
          >
            <ListItemIcon sx={{ minWidth: 36 }}>
              {renderSwatch(styleId)}
            </ListItemIcon>
            <ListItemText primary={t(`theme.styles.${styleId}`)} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ThemeSwitcher;
